import { render, staticRenderFns } from "./AddEditComponents.vue?vue&type=template&id=cba38494"
import script from "./AddEditComponents.vue?vue&type=script&lang=js"
export * from "./AddEditComponents.vue?vue&type=script&lang=js"
import style0 from "./AddEditComponents.vue?vue&type=style&index=0&id=cba38494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports